import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft } from "lucide-react";
import { usePollBySlug } from "@core/hooks/usePoll";
import { ProductHeader } from "@core/components/layout/products/ProductHeader";
import { ProductSidebar } from "@core/components/layout/products/ProductSidebar";
import { PollInvitationList } from "@core/components/PollInvitationList";
import { Button } from "@core/components/ui/button";
import { SEOHead } from "../components/SEOHead";

/**
 * Page de gestion des invitations pour un sondage de dates.
 * Réutilise PollInvitationList (packages/core), déjà branché sur
 * poll_invitations / resend_poll_invitation.
 */
export default function PollInvitations() {
  const { t } = useTranslation();
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();
  const { data: poll, isLoading } = usePollBySlug(slug);

  return (
    <div className="flex flex-col min-h-screen-safe bg-background">
      <SEOHead title={t("polls:invitations.tracking.panel_title")} noIndex />
      <ProductHeader productType="date" showAuth={true} />
      <div className="flex flex-1">
        <ProductSidebar productType="date" />
        <div className="flex-1 max-w-3xl mx-auto w-full p-4 sm:p-6">
          <Button
            type="button"
            variant="ghost"
            size="sm"
            onClick={() => navigate(`/poll/${slug}/results`)}
            className="mb-4 -ml-2"
            data-testid="poll-invitations-back"
          >
            <ArrowLeft className="h-4 w-4 mr-1" />
            {t("polls:results.back")}
          </Button>

          {isLoading || !poll ? (
            <div className="flex items-center justify-center py-12">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
            </div>
          ) : (
            <PollInvitationList pollId={poll.id} showWhenEmpty />
          )}
        </div>
      </div>
    </div>
  );
}
